import React, { Component } from 'react'
import heartIcon from './../assets/img/heart.svg'
import logoImg from './../assets/img/encrypto-logo.png';
export class Header extends Component {
    render() {
        const {github , sitename} = this.props ;
        return (
            <header>
                <div className="neo-out" >
                    <div className="__container header ">
                        <div className="header__navbar grid grid-cols-12">
                            <span className="font-bold col-span-6 ">
                                <img src={logoImg} alt="logo" className="__logo" />
                            </span>

                            <div className="col-span-6">
                                <a href={github}>
                                    <img className="w-[25px] h-auto ml-auto __like" src={heartIcon} alt={sitename} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}

export default Header